<template lang="html">
  <section class="merge-list-edit">
    <name-input
      :all-des="allDes"
      :is-ready="true"
      :name="de.name"
      :should-focus="!storedDataElement.name"
      :de-id="de.id"
      @on-name-input-changed="onDeNameChanged"
    ></name-input>

    <element-description
      :is-ready="true"
      :elem-description="de.description"
      @on-element-description-changed="onDeDescriptionChanged"
    ></element-description>

    <div class="row-container">
      <label class="query-label data-source-header">
        {{ getMessageText(messages.DATA_SOURCE) }}
      </label>
      <div
        v-for="(val, index) in selectedSourceValues"
        :key="index"
        :id="index"
        class="ds-select"
      >
        <search-box-simple
          class="search-box-merge-list"
          :id="index.toString()"
          :should-focus="shouldFocus(val, index)"
          :list="sourceList"
          :value="selectedSourceValues[index]"
          :has-icon="false"
          @on-search-box-item-selected="onSourceSelected"
        />
        <div class="delete-wrapper delete-row-datasource">
          <svg
            class="delete-row-icon"
            tabindex="0"
            @keydown.enter.stop="deleteModal(index, deleteDataSource)"
            @click="deleteModal(index, deleteDataSource)"
            v-if="selectedSourceValues.length > 1"
          >
            <use
              xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#delete"
            ></use>
          </svg>
        </div>
      </div>
      <button
        class="modal-btn no-user-select modal-cancel-btn datasource-btn"
        @click="addDataSource"
      >
        {{ $t("add") }}
      </button>
    </div>

    <div class="row-container">
      <label class="query-label field-header">
        {{ $t("fields") }}
      </label>
    </div>
    <div class="m-table_columns">
      <div
        v-for="(value, index_field_labels) in selectedFieldLabels"
        :key="index_field_labels"
        :id="index_field_labels"
        class="ds-select"
      >
        <div class="row-container">
          <text-input
            :id="'field-name-' + index_field_labels"
            type="text"
            :value="value.label"
            :focus="index_field_labels > 0 && value.isEmpty"
            @on-text-input-change="onFieldInputChanged"
            class="query-label"
          />
          <div
            v-for="(val, index_datasource_field) in selectedSourceValues"
            :key="index_datasource_field"
            :id="index_datasource_field"
            class="ds-select data-source-field"
          >
            <search-box-simple
              class="search-box-merge-list"
              :id="
                `field-label-${index_field_labels}_datasource-field-${index_datasource_field}`
              "
              :list="
                filterDatasourceFields(
                  selectedDatasourceFields,
                  index_datasource_field,
                  index_field_labels
                )
              "
              :value="
                selectedFieldLabels[index_field_labels].fieldList[
                  index_datasource_field
                ]
              "
              :has-icon="true"
              @on-search-box-item-selected="onFieldSelected"
            />
          </div>
          <div class="delete-wrapper delete-row-field">
            <svg
              class="delete-row-icon"
              tabindex="0"
              @keydown.enter.stop="
                deleteModal(index_field_labels, deleteFieldListRow)
              "
              @click="deleteModal(index_field_labels, deleteFieldListRow)"
              v-if="selectedFieldLabels.length > 1"
            >
              <use
                xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#delete"
              ></use>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="row-container">
      <button
        class="modal-btn no-user-select modal-cancel-btn"
        @click="addField"
      >
        {{ $t("add") }}
      </button>
    </div>
  </section>
</template>

<script lang="js">
  import { mapState, mapActions } from "vuex";
  import { MUTATION_NAME } from "@/static/global-variables";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import SearchBoxSimple from "@/components/SearchBoxSimple";
  import NameInput from "@/components/NameInput";
  import ElementDescription from "@/components/ElementDescription";
  import TextInput from "@/components/TextInput";
  import utils from "@/utils";

  export default  {
    name: "merge-list-edit",
    components: {
      SearchBoxSimple,
      NameInput,
      TextInput,
      ElementDescription
    },
    props: {
      appId: {
       type: String
      },
      allDes: {
        type: Object
      },
      de: {
        type: Object
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      sourceList() {
        return this.dataSources.map(e => {
          e.label = e.name;
          return e;
        });
      },
      dataSources() {
        delete this.allDes[this.de.id];
        return expressionBuilder.filterGlobalSources(this.allDes);
      },
      selectedSourceValues() {
        return this.storedDataElement.selectedSources;
      },
      selectedFieldLabels() {
        return this.storedDataElement.fieldLabels;
      },
      selectedDatasourceFields() {
        return this.storedDataElement.selectableDatasourceFields;
      },
    },
    watch: {
      fieldLabels: {
        handler: function() {
          this.getAvailableFields();
        },
        deep: true,
        immediate: true
      },
      sourceList: {
        handler: function() {
          this.storedDataElement.selectedSources = this.setSources(this.de.sources.map(element => element.dataSource));
          this.getAvailableFields();
        },
        deep: true,
        immediate: true
      }
    },
    mounted () {
      this.elDataName = "mergelistid";
      if(this.storedDataElement.selectedSources.length === 0) {
        this.addDataSource();
        this.addField();
      }
    },
    data () {
      return {
        minHeight: "",
        storedDataElement: {
          type: "DATA_EL_MERGE_LIST",
          name: this.de.name,
          description: this.de.description,
          selectedSources: [],
          fieldLabels: utils.setFieldLabels(this.de.sources, this.de.fieldOrder, this.allDes) || [],
          selectableDatasourceFields: []
        },
        comparables: {
          STRING: true,
          NUMBER: true,
          DATE: true
        }
      }
    },
    methods: {
      ...mapActions({
        setDataElement: MUTATION_NAME.SET_EDIT_DATA_ELEMENT
      }),
      shouldFocus(val, index) {
        return index === this.selectedSourceValues.length - 1 && index !== 0 && val.isEmpty;
      },
      onSourceSelected(val) {
        if(val.isEmpty) {
          this.clearFieldListColumn(parseInt(val.searchBoxId));
        }
        this.storedDataElement.selectedSources = this.storedDataElement.selectedSources.map((elm, index) => {
          if(index === parseInt(val.searchBoxId)) {
            return val;
          }
          return elm;
        });
        this.setDataElement(this.storedDataElement);
        this.getAvailableFields();
      },
      onFieldSelected(val) {
        const ids = val.searchBoxId.split("_");
        const fieldLabelId = parseInt(ids[0].replace("field-label-",""));
        const dataSourceId = parseInt(ids[1].replace("datasource-field-",""));

        delete val.searchBoxId;
        this.storedDataElement.fieldLabels[fieldLabelId].fieldList[dataSourceId] = val;
        let rowFieldType = this.storedDataElement.fieldLabels[fieldLabelId].fieldType;
        if(!rowFieldType && val.dataType) {
          rowFieldType = val.dataType
        } else if(val.isEmpty){
          if(this.isEmptyArray(this.storedDataElement.fieldLabels[fieldLabelId].fieldList)){
            rowFieldType = "";
          }
        }
        this.storedDataElement.fieldLabels[fieldLabelId].fieldType = rowFieldType;
        this.setDataElement(this.storedDataElement);
        this.getAvailableFields();
      },
      addField() {
        const newFieldLabel = {
          "isEmpty": true
        };
        this.storedDataElement.fieldLabels.push(newFieldLabel);
        this.addFieldListElement([newFieldLabel], this.storedDataElement.selectedSources.length);
      },
      addDataSource() {
        this.storedDataElement.selectedSources.push({
          "isEmpty": true
        });
        this.addFieldListElement(this.storedDataElement.fieldLabels, 1);
        this.getAvailableFields();
      },
      getOriginSourceType(dataElementQuestioned) {
        const obfuscatingDataElements = ["DATA_EL_SORT_LIST", "DATA_EL_FILTER_LIST", "DATA_EL_SUBLIST"];
        let originalDataElement = obfuscatingDataElements.includes(dataElementQuestioned.type)
            ? this.allDes[dataElementQuestioned.original]
            : dataElementQuestioned;
        if (originalDataElement && obfuscatingDataElements.includes(originalDataElement)) {
          originalDataElement = this.findOriginalDataSource(
              this.allDes,
              originalDataElement
          );
        }
        return originalDataElement.type;
      },
      getAvailableFields() {
        this.storedDataElement.selectableDatasourceFields = this.storedDataElement.selectedSources.map((elm) => {
          if(!elm.fields) {
            return [];
          }
          const order = [];
          if(elm.type === "DATA_EL_CRM_DATA_ENGINE" || this.getOriginSourceType(elm) === "DATA_EL_CRM_DATA_ENGINE") {
            for (const field of elm.fields) {
              order.push({"name": field.as ? field.as : field.field, "label": field.label, "dataType": field.dataType})
            }
          } else {
            new Map(Object.entries(elm.fields)).forEach((value, key) => {
              order.push({"name": key, "label": value.label, "dataType": value.dataType})
            })
          }
          return order;
        });
      },
      deleteDataSource(id) {
        this.storedDataElement.selectedSources = this.storedDataElement.selectedSources.filter((element, index) => { return id !== index });
        this.deleteFieldListColumn(id);
        this.getAvailableFields();
        this.setDataElement(this.storedDataElement);
      },
      onFieldInputChanged(val, id) {
        const fieldId = id.replace("field-name-", "");
        this.storedDataElement.fieldLabels[parseInt(fieldId)].label = val;
        this.storedDataElement.fieldLabels[parseInt(fieldId)].isEmpty = val === "";
        this.setDataElement(this.storedDataElement);
      },
      addFieldListElement(fieldLabelElements, emptyFieldCount) {
        fieldLabelElements.forEach(element => {
          let count = emptyFieldCount;
          if(!('fieldList' in element)) {
            element.fieldList = [];
          }
          while(count > 0) {
            element.fieldList.push({"isEmpty": true});
            count--;
          }
        });
      },
      deleteFieldListColumn(id) {
        this.storedDataElement.fieldLabels.forEach(element => {
          element.fieldList = element.fieldList.filter((elm, index) => { return id !== index })
        });
        this.setDataElement(this.storedDataElement);
      },
      deleteFieldListRow(id) {
        this.storedDataElement.fieldLabels = this.storedDataElement.fieldLabels.filter((elm, index) => { return id !== index })
        this.setDataElement(this.storedDataElement);
      },
      clearFieldListColumn(id) {
        this.storedDataElement.fieldLabels.forEach(element => {
          element.fieldList[id] = {"isEmpty": true};
        });
        this.setDataElement(this.storedDataElement);
      },
      isEmptyArray(arr) {
        for(const element of arr) {
          if(!(element.isEmpty)) {
            return false;
          }
        }
        return true;

      },
      setSources(datasourceIds) {
        const selectSources = [];
        if(datasourceIds !== undefined) {
          datasourceIds.forEach(element => {
            const source = this.sourceList.find(listDataEl => listDataEl.id === element)
            if(source !== undefined) {
              selectSources.push(source);
            } else {
              selectSources.push({
                isEmpty: true
              });
            }
          });
        }
        return selectSources;
      },
      filterDatasourceFields(arr,index_datasource_field, index_field_labels ) {
        if(arr.length === 0) return [];
        return arr[index_datasource_field].filter(
          element => {
            if (
              this.selectedFieldLabels[index_field_labels] &&
              this.selectedFieldLabels[index_field_labels].fieldType
            ) {
              return (
                element.dataType.toLowerCase() ===
                this.selectedFieldLabels[index_field_labels].fieldType.toLowerCase()
              );
            }
            return true;
          }
        )
      },
      deleteModal(id, thenCallFunction) {
        this.$bvModal.msgBoxConfirm(this.getMessageText(this.messages.ARE_YOU_SURE), {
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.getMessageText(this.messages.OK),
          cancelTitle: this.getMessageText(this.messages.CANCEL),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if (value) {
              thenCallFunction(id);
            }
          })
          .catch(err => {
            console.error(err);
          });
      },
      onDeNameChanged(isValidName, nameInput) {
        this.storedDataElement.name = nameInput;
        this.$emit("on-de-name-changed", isValidName);
        this.setDataElement(this.storedDataElement);
      },
      onDeDescriptionChanged(input) {
        this.storedDataElement.description = input;
        this.setDataElement(this.storedDataElement);
      }
    }
  }
</script>

<style scoped lang="scss">
  .merge-list-edit {
    min-height: 8rem;
    .row-container {
      display: flex;
      padding: 0 1rem;
      margin-top: 1rem;
      margin-bottom: 1rem;
      min-width: 45rem;
    }
    .query-label {
      max-width: 80px;
      padding-right: 0.5rem;
      margin-bottom: 0;
    }
    .delete-row-icon {
      height: 1rem;
      width: 1rem;
      fill: #c23934;
      cursor: pointer;
    }
    .delete-row-datasource {
      display: flex;
      justify-content: right;
      padding-top: 0.25rem;
      padding-right: 0.625rem;
    }
    .delete-row-field {
      display: flex;
      align-items: center;
    }
    .data-source-header {
      align-self: center;
      margin-bottom: 1rem;
    }
    .field-header {
      align-self: center;
    }
    .fields-label {
      padding-top: 0.6rem;
    }
    .ds-select {
      padding-right: 0.5rem;
      align-items: center;
    }
    .search-box-merge-list {
      max-width: 180px;
      min-width: 180px;
    }
    .btn-container {
      padding: 1rem 1rem 0;
      .add-btn {
        padding: 0;
        background: transparent;
        background-clip: border-box;
        border: 1px solid transparent;
        border-radius: 0.25rem;
        line-height: 1.875rem;
        color: #0070d2;
        -webkit-appearance: none;
        white-space: normal;
      }
    }
    .datasource-btn {
      height: fit-content;
    }
  }
</style>
